export const PRODUCT_PAGES_IMAGES_DETAILS_CHECK_STATUS = {
    NO_MATCH: 'no_match',
    NO_DATE_MATCH: 'no_date_match',
    NO_POSITION_MATCH: 'no_position_match',
    FULL_MATCH: 'full_match'
}

export const PRODUCT_PAGES_IMAGES_DETAILS_STATUS = {
    GOOD: 'Good',
    FIX: 'Fix'
}